import React from 'react';

import { formatPrice } from '../../../../utils';

const getCouponDiscount = (total, subtotal) => {
  return total < subtotal ? `${(100 - (total / subtotal) * 100).toFixed()}% off no cupom` : '';
};

const getPaymentMethodDiscount = (paymentMethod) => {
  return paymentMethod && paymentMethod.discount > 0 ? `${paymentMethod.discount}% off para ${paymentMethod.name}` : '';
};

const DiscountBlock = ({ paymentMethods, purchaseSummary , paymentMethodSlug}) => {
  const { subtotal, total, coupon_discount } = purchaseSummary;
  const paymentMethod = paymentMethods.find((method) => method.slug === paymentMethodSlug);

  const couponDiscount = coupon_discount > 0 ? getCouponDiscount(total, subtotal) : '';
  const paymentMethodDiscount = getPaymentMethodDiscount(paymentMethod);

  const discounts = [couponDiscount, paymentMethodDiscount].filter(Boolean).join(' + ');

  if (!discounts) return '';

  return (
    <div className="discount">
      <s>R$ ${formatPrice(subtotal)}</s>
      <span> (${discounts})</span>
    </div>
  );
};

export default DiscountBlock;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/DiscountBlock.jsx